import { getTheme } from 'mol-ui';
import styled from 'styled-components';

export const Background = styled.div`
    align-items: center;
    background: ${ ({ theme: { grayBackground } }) => grayBackground };
    display: flex;
    height: 100vh;
    justify-content: center;
    overflow: auto;
    width: 100%;
    @media (max-width: 575px) {
        height: 100%;
        position: fixed;
    }
`;

export const Brand = styled.div`
    align-items: center;
    background: ${ ({ theme: { whiteBackground } }) => whiteBackground };
    border: 1px solid ${ ({ theme: { primaryColor } }) => primaryColor };
    border-radius: 100%;
    box-shadow: 0px 0px 5px 3px ${ ({ theme: { primaryLighterColor } }) => primaryLighterColor };
    display: flex;
    height: 150px;
    justify-content: center;
    left: calc(50% - 75px);
    overflow: hidden;
    position: absolute;
    top: -75px;
    width: 150px;

    img {
        object-fit: contain;
        width: ${ getTheme('logoWidth') };
    }

    @media (max-width: 575px) {
        left: calc(50% - 45px);
        height: 90px;
        top: -45px;
        width: 90px;
    }
`;

export const Form = styled.form`
    background: ${ ({ theme: { whiteBackground } }) => whiteBackground };
    border: 1px solid ${ ({ theme: { primaryColor } }) => primaryColor };
    border-radius: 4px;
    box-shadow: 0px 0px 3px 3px ${ ({ theme: { primaryLighterColor } }) => primaryLighterColor };
    padding: 40px;
    position: relative;
    width: 500px;
`;

export const Title = styled.h1`
    color: ${ ({ theme: { textColor } }) => textColor };
    font-weight: 300;
    font-size: 24px;
    margin: 60px 0px 20px 0px;
    text-align: center;
    @media (max-width: 575px) {
        margin: 30px 0px 20px 0px;
    }
`;
